import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_EXCEPTIONS_ACTION_TYPE = createNamedActions('loanExceptions', {
  GET_FOR_LOAN: 'GET_FOR_LOAN',
  GET_BY_ID: 'GET_BY_ID',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DECIDE: 'DECIDE',
  WITHDRAW: 'WITHDRAW',
  CLEAR: 'CLEAR',
});

export const LoanExceptionCategory = {
  PRICING: 'PricingException',
  UNDERWRITING_GUIDELINE: 'UnderwritingException',
  FEE_ADJUSTMENT_TO_AVOID_HPML: 'FeeAdjustmentToAvoidHpml',
  CREDIT_COMMITTEE: 'CreditCommitteeException',
};

export const LoanExceptionStatus = {
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'UnderReview',
  APPROVED: 'Approved',
  DENIED: 'Denied',
  WITHDRAWN: 'Withdrawn',
};

export const LoanExceptionOutcome = {
  APPROVED_AS_REQUESTED: 'ApprovedAsRequested',
  APPROVED_WITH_CHANGES: 'ApprovedWithChanges',
  DENIED: 'Denied',
  NOT_PURSUED: 'NotPursued',
};

export const LoanExceptionLinkedEntityType = {
  MANUAL: 'Manual',
  OPTIMAL_BLUE_PRICE_CONCESSION: 'OptimalBluePriceConcession',
  CHECKLIST_OVERRIDE: 'ChecklistOverride',
  LOAN_FEE_CHANGE: 'LoanFeeChange',
};

export const LoanExceptionDecision = {
  APPROVED: 'Approved',
  DENIED: 'Denied',
};
